<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" :before-close="beforeClose" class="dialog-w50">
    <el-form :model="form" :rules="rules" ref="form">
    <h2 class="text-center mt-0">Сформировать отчет</h2>

    <div class="row mt-4">
      <h3 class="col-12 mb-3">Дата оказания услуги</h3>
      <div class="col-6">
        <el-form-item prop="fromDate">
          <el-date-picker v-model="form.fromDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                          class="w-100" placeholder="с" :pickerOptions="pickerOptions('fromDate')" />
        </el-form-item>
      </div>
      <div class="col-6">
        <el-form-item prop="toDate">
          <el-date-picker v-model="form.toDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                          class="w-100" placeholder="по" :pickerOptions="pickerOptions('toDate')" />
        </el-form-item>
      </div>
    </div>

    <div class="row mt-2">
      <h3 class="col-12 mb-3">Дата создания рекламации</h3>
      <div class="col-6">
        <el-form-item prop="fromClaimCreatedDate">
          <el-date-picker v-model="form.fromClaimCreatedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                          class="w-100" placeholder="с" :pickerOptions="pickerOptions('fromClaimCreatedDate')" />
        </el-form-item>
      </div>
      <div class="col-6">
        <el-form-item prop="toClaimCreatedDate">
          <el-date-picker v-model="form.toClaimCreatedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                          class="w-100" placeholder="по" :pickerOptions="pickerOptions('toClaimCreatedDate')" />
        </el-form-item>
      </div>
    </div>

    <div class="row mt-2">
      <h3 class="col-12 mb-3">Дата обработки рекламации</h3>
      <div class="col-6">
        <el-form-item prop="fromClaimProcessedDate">
          <el-date-picker v-model="form.fromClaimProcessedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                          class="w-100" placeholder="с" :pickerOptions="pickerOptions('fromClaimProcessedDate')" />
        </el-form-item>
      </div>
      <div class="col-6">
        <el-form-item prop="toClaimProcessedDate">
          <el-date-picker v-model="form.toClaimProcessedDate" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                          class="w-100" placeholder="по" :pickerOptions="pickerOptions('toClaimProcessedDate')" />
        </el-form-item>
      </div>
    </div>

    <div v-if="dateIsEmpty" class="alert alert-danger mt-2">Для формирования отчета укажите не менее одного периода</div>

    <el-checkbox class="mb-2" v-model="considerFilterPreset" label=""
                @change="onChangeConsiderFilterPreset">Учесть настроенные фильтры</el-checkbox>

    <h3 class="mt-4 mb-3">Выберите столбцы для отчета:</h3>

    <el-checkbox class="mb-2" :value="allSelected" @change="onAllSelected" label="">Выделить все</el-checkbox>

    <div class="column-count-2">
      <el-checkbox-group v-model="params">
        <div v-for="item in reportItems" :key="item.key" class="py-2">
          <el-checkbox :label="item.key">{{ item.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <div class="row mt-5">
      <div class="col-12 col-lg-6 mx-auto">
        <el-button class="w-100" type="primary" @click="onSubmit" :loading="importExportProgress">
          Выгрузить в Excel
        </el-button>
      </div>
    </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { fixDateInterval } from '@/commons/helpers';

const { isEmpty } = require('lodash');

const reportItems = [
  { key: 'includeIsClaimProcessed', label: 'Обработка' },
  { key: 'includeContractor', label: 'Подрядчик' },
  { key: 'includeWorker', label: 'Исполнитель' },
  { key: 'includeWorkDate', label: 'Дата оказания услуги' },
  { key: 'includeService', label: 'Тип заказа' },
  { key: 'includeRegistryType', label: 'Тип реестра' },
  { key: 'includeShop', label: 'Магазин' },
  { key: 'includeClientName', label: 'Клиент' },
  { key: 'includeCancellationReason', label: 'Причина отмены' },
  { key: 'includeClaimReason', label: 'Причина рекламации' },
  { key: 'includeStatusReason', label: 'Причина ложного выезда' },
  { key: 'includeAddress', label: 'Адрес' },
  { key: 'includeServiceDetail', label: 'Детализация услуги' },
  { key: 'includeNumber', label: 'Номер заказа' },
  { key: 'includeStatus', label: 'Статус заказа' },
  { key: 'includeClaimCreationDate', label: 'Дата создания рекламации' },
  { key: 'includeClaimProcessingDate', label: 'Дата обработки рекламации' },
  { key: 'includeClaimProcessingComment', label: 'Комментарий к обработке' },
  { key: 'includeAttachedFile', label: 'Наличие вложений' },
  { key: 'includeCallRecord', label: 'Наличие записей звонков' },
  { key: 'includeGoodsSum', label: 'Сумма по товарам' },
  { key: 'includeServicesSum', label: 'Сумма по артикулам услуг' },
  { key: 'includeSalesOrders', label: 'Заказы на продажу' },
];

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      params: [],

      considerFilterPreset: false,

      form: {
        fromDate: null,
        toDate: null,
        fromClaimCreatedDate: null,
        toClaimCreatedDate: null,
        fromClaimProcessedDate: null,
        toClaimProcessedDate: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      importExportProgress: 'orders/importExportProgress',
      filter: 'orders/filter',
    }),

    dateIsEmpty() {
      return ![
        this.form.fromDate,
        this.form.toDate,
        this.form.fromClaimCreatedDate,
        this.form.toClaimCreatedDate,
        this.form.fromClaimProcessedDate,
        this.form.toClaimProcessedDate,
      ].some((x) => !!x);
    },

    rules() {
      return this.getRules();
    },
    reportItems() {
      return reportItems.filter((x) => !(x.key === 'includeClientName' && this.user.userRole === this.$userRoles.Dispatcher));
    },

    allSelected() {
      return this.params.length === this.reportItems.length;
    },
  },
  methods: {
    ...mapActions({
      exportReport: 'orders/exportReport',
    }),
    getRules() {
      return {
        fromDate: { required: !!this.form.toDate, message: MESSAGES.REQUIRED, trigger: 'change' },
        toDate: { required: this.form.fromDate, message: MESSAGES.REQUIRED, trigger: 'change' },
        fromClaimCreatedDate: { required: !!this.form.toClaimCreatedDate, message: MESSAGES.REQUIRED, trigger: 'change' },
        toClaimCreatedDate: { required: !!this.form.fromClaimCreatedDate, message: MESSAGES.REQUIRED, trigger: 'change' },
        fromClaimProcessedDate: { required: !!this.form.toClaimProcessedDate, message: MESSAGES.REQUIRED, trigger: 'change' },
        toClaimProcessedDate: { required: !!this.form.fromClaimProcessedDate, message: MESSAGES.REQUIRED, trigger: 'change' },
      };
    },
    pickerOptions(key) {
      const options = {
        firstDayOfWeek: 1,
        disabledDate: null,
      };
      const oneDayMs = 60 * 60 * 24 * 1000;

      const fromDateDisableDate = (toDate) => (time) => (time.getTime() < this.$moment(toDate).subtract(1, 'months'))
        || (time.getTime() > Date.parse(toDate));
      const toDateDisableDate = (fromDate) => (time) => (time.getTime() > this.$moment(fromDate).add(1, 'months'))
        || time.getTime() < Date.parse(fromDate) - oneDayMs;

      switch (key) {
        case 'fromDate': options.disabledDate = fromDateDisableDate(this.form.toDate); break;
        case 'toDate': options.disabledDate = toDateDisableDate(this.form.fromDate); break;

        case 'fromClaimCreatedDate': options.disabledDate = fromDateDisableDate(this.form.toClaimCreatedDate); break;
        case 'toClaimCreatedDate': options.disabledDate = toDateDisableDate(this.form.fromClaimCreatedDate); break;

        case 'fromClaimProcessedDate': options.disabledDate = fromDateDisableDate(this.form.toClaimProcessedDate); break;
        case 'toClaimProcessedDate': options.disabledDate = toDateDisableDate(this.form.fromClaimProcessedDate); break;
        default:
      }

      return options;
    },
    beforeClose(done) {
      if (!this.importExportProgress) {
        done();
      }
    },
    onChangeConsiderFilterPreset(value) {
      if (value) {
        this.form = {
          fromDate: this.filter.workDateFrom,
          toDate: fixDateInterval(this.filter.workDateFrom, this.filter.workDateTo),
          fromClaimCreatedDate: this.filter.claimCreationDateFrom,
          toClaimCreatedDate: fixDateInterval(this.filter.claimCreationDateFrom, this.filter.claimCreationDateTo),
          fromClaimProcessedDate: this.filter.claimProcessingDateFrom,
          toClaimProcessedDate: fixDateInterval(this.filter.claimProcessingDateFrom, this.filter.claimProcessingDateTo),
          claimProcessed: this.filter.claimProcessed
            ? this.filter.claimProcessed === 'true'
            : null,
          statusIds: this.filter.statusIds.map((item) => +item),
          serviceIds: this.filter.serviceIds.map((item) => +item),
          registryTypeIds: this.filter.registryTypeIds.map((item) => +item),
          shop: this.filter.shop,
          contractorIds: this.filter.contractorIds.map((item) => +item),
          workerIds: this.filter.workerId,
          cancellationReasonIds: this.filter.cancellationReasonIds.map((item) => +item),
          claimReasonIds: this.filter.claimReasonIds.map((item) => +item),
        };
      } else {
        this.form = {
          fromDate: null,
          toDate: null,
          fromClaimCreatedDate: null,
          toClaimCreatedDate: null,
          fromClaimProcessedDate: null,
          toClaimProcessedDate: null,
        };
      }
    },
    onAllSelected(value) {
      this.params = value ? this.reportItems.map((r) => r.key) : [];
    },
    onSubmit() {
      if (this.dateIsEmpty) {
        return;
      }
      this.$refs.form.validate((valid) => {
        const params = { queryFilters: {}, reportFieldOptions: {} };
        if (valid) {
          this.params.forEach((key) => {
            params.reportFieldOptions[key] = true;
          });
          Object.keys(this.form).forEach((key) => {
            if (!isEmpty(this.form[key]) || typeof this.form[key] === 'boolean') params.queryFilters[key] = this.form[key];
          });

          this.exportReport({ params })
            .then((response) => {
              saveAs(response, `Отчет_${this.$moment().format('DD-MM-YYYY_HH-mm-SS')}.xlsx`);
              this.$emit('update:visible', false);
            });
        }
      });
    },
  },
};
</script>
